import { useEffect, useState } from 'react'

/**
 * A hook that observes the DOM for changes and
 * returns the first element that matches the given selector.
 **/
export function useQuerySelector(selector: string) {
  const [element, setElement] = useState<Element | null>(null)

  useEffect(() => {
    const observer = new MutationObserver(() => {
      const element = document.querySelector(selector)
      setElement(element)
    })

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    })

    return () => {
      observer.disconnect()
    }
  }, [selector])

  return element
}
